import Layout from '@/layout';
import { $vi18n } from '@/utils/i18n.js';
// import exchangeShop from './exchangeShop';

// console.log('exchangeShop router----', exchangeShop);

export default [
  {
    path: '/income',
    name: 'Income',
    redirect: '/income/data',
    component: Layout,
    meta: {
      title: $vi18n('$i18n# 收益管理 #i18n$'),
      icon: 'icon-income',
    },
    children: [
      {
        path: 'rules',
        component: () => import('@/views/rules.vue'),
        name: 'rules',
        hidden: true,
        meta: {
          activePath: 'settlement',
        }
      },
      {
        path: 'data',
        name: 'IncomeData',
        component: () => import('@/views/income/Data'),
        meta: {
          title: $vi18n('$i18n# 收益数据 #i18n$'),
        },
      },
      {
        path: 'settlement',
        name: 'IncomeSettlement',
        component: () => import('@/views/income/Settlement'),
        meta: {
          title: $vi18n('$i18n# 结算中心 #i18n$'),
        },
      },
      // {
      //   path: 'billCenter',
      //   name: 'billCenter',
      //   component: () => import('@/views/income/billCenter.vue'),
      //   meta: {
      //     title: '$vi18n('$i18n# 账单中心 #i18n$')',
      //   },
      // },
      {
        path: 'billCenter/detail',
        name: 'billCenterDetail',
        component: () => import('@/views/income/billCenterDetail.vue'),
        meta: {
          title: $vi18n('$i18n# 账单详情 #i18n$'),
          activePath: 'billCenter',
        },
        hidden: true
      },
      // {
      //   path: 'dataDetail',
      //   name: 'dataDetail',
      //   component: () => import('@/views/income/dataDetail'),
      //   meta: {
      //     title: '$vi18n('$i18n# 账单详情 #i18n$')',
      //     activePath: 'data',
      //   },
      //   hidden: true,
      // },
      {
        path: 'withdrawalRecord',
        name: 'withdrawalRecord',
        component: () => import('@/views/income/withdrawalRecord.vue'),
        meta: {
          title: $vi18n('$i18n# 账单中心 #i18n$')
        }
      },
      {
        path: 'settlementDetail',
        name: 'settlementDetail',
        component: () => import('@/views/income/settlementDetail'),
        meta: {
          title: $vi18n('$i18n# 提现记录 #i18n$'),
          activePath: 'settlement',
        },
        hidden: true,
      },
      {
        path: 'payInfo',
        name: 'payInfo',
        component: () => import('@/views/income/payInfo/index.vue'),
        meta: {
          title: $vi18n('$i18n# 支付设置 #i18n$'),
        }
      },
      // {
      //   path: 'settlementSet',
      //   name: 'settlementSet',
      //   component: () => import('@/views/income/settlementSet'),
      //   meta: {
      //     title: '$vi18n('$i18n# 结算设置 #i18n$')',
      //     activePath: 'settlement',
      //   },
      //   hidden: true,
      //   children: [
      //     {
      //       path: 'bindForm',
      //       name: 'bindForm',
      //       component: () =>
      //         import('@/views/income/components/resultSet/bindForm'),
      //       meta: {
      //         title: '$vi18n('$i18n# 绑定银行卡 #i18n$')',
      //         activePath: 'settlement',
      //       },
      //       hidden: true,
      //     },
      //     {
      //       path: 'bindInfo',
      //       name: 'bindInfo',
      //       component: () =>
      //         import('@/views/income/components/resultSet/bindInfo.vue'),
      //       meta: {
      //         title: '$vi18n('$i18n# 绑定信息 #i18n$')',
      //         activePath: 'settlement',
      //       },
      //       hidden: true,
      //     },
      //   ],
      // },
      // exchangeShop[0].children[0],
    ],
  },
];
